export const refineAnalytics = (type, data, showHistory = 1, showOverview = 1) => {
	const { details, history, overview } = data

	let refinedData = {
		details,
		history: {},
		overview: {},
		overview_agency: {}
	}

	// History
	if (showHistory) {
		refinedData.history.labels = Object.keys(history)
		refinedData.history.values = Object.values(history)
	}

	// Overview
	if (showOverview) {
		refinedData.overview.labels = Object.keys(overview).map(item => {
			return overview[item].details.name
		})
		refinedData.overview.values = Object.keys(overview).map(item => {
			return overview[item].count
		})
	}

	if (type === 'nema') {
		refinedData.overview_agency.labels = Object.keys(data.overview_agency).map(item => {
			return data.overview_agency[item].details.name
		})
		refinedData.overview_agency.values = Object.keys(data.overview_agency).map(item => {
			return data.overview_agency[item].count
		})
	}

	return refinedData
}
